import Base64 from "crypto-js/enc-base64";
import Utf8 from "crypto-js/enc-utf8";
import { creatUUid } from "@/api/http/utils/apiHelpers";
import { getTimeZone, getLang, isIpad } from "@/utils/lodash";
import store from "@/store/index";
import * as types from "@/store/constants/types";
/**
 * 添加的拦截器功能：
 */
//=================== [REQUEST] ===============================
import { defaultParams } from "@/api/http/gx/gxConst";
import Http from "@/api/http/fetch";
/**
 * 添加默认的头和baseURL
 */
const parseGetParam = (params: any) => {
  let result = ``;
  Object.keys(params).forEach(key => {
    result += `&${key}=${params[key]}`;
  });
  return result;
};

const addBodyDefaultParams = async (params: any) => {
  const AppInfo: any = await Http.AppInfo();
  console.log("AppInfo获取到：", AppInfo);
  const defaultBodyParams: any = {
    platform: AppInfo.GETX_PLATFORM,
    app_version: AppInfo.VERSION_NAME,
    js_bundle_version: "2.2.2",
    timestamp: new Date().valueOf().toString(),
    request_id: creatUUid(),
    timezone: getTimeZone(),
    // lang: getLang(),
    pad: isIpad()
  };

  if (AppInfo.SYSTEM_VERSION) {
    defaultBodyParams.system_version = AppInfo.SYSTEM_VERSION;
  }
  if (AppInfo.SYSTEMINFO) {
    defaultBodyParams.device_model = AppInfo.SYSTEMINFO;
  }
  if (store && store.getters[types.GETTER_DEVICE_ID]) {
    defaultBodyParams.device_id = store.getters[types.GETTER_DEVICE_ID];
  }
  if (AppInfo.VERIFY_ID) {
    defaultBodyParams.platform_info = AppInfo.VERIFY_ID;
  }

  console.log("defaultBodyParams:", defaultBodyParams);
  // defaultBodyParams.lang = AppInfo.LANG + "_" + AppInfo.COUNTRY; // open low version settings

  if (params === null || params === undefined) {
    params = defaultBodyParams;
    return params;
  } else {
    params = { ...defaultBodyParams, ...params };
    return params;
  }
};

export const addDefaultParamsAndEncrypt = async (config: any) => {
  const dataBody = {
    method: config.method,
    path: config.url,
    query: "",
    body: ""
  };
  if (config.method === "GET") {
    config.params = await addBodyDefaultParams(config.params);
    dataBody.query = parseGetParam(config.params);
  } else {
    config.data = await addBodyDefaultParams(config.data);
    dataBody.body = config.data;
  }
  console.log("dataBody", dataBody);
  const dataStr = JSON.stringify(dataBody);
  const encryptData = await Http.gxEncrypt(dataStr);
  const paramsData = {
    zv: `gps`,
    data: encryptData
  };
  if (
    config.extra.hasOwnProperty("encryptHandle") &&
    !config.extra.encryptHandle
  ) {
    return {
      baseURL: config.url,
      method: config.method,
      data: config.data,
      extra: config.extra
    };
  }
  return {
    ...defaultParams,
    data: paramsData,
    extra: config.extra
  };
};

//==================== [RESPONSE] =============================
/**
 * 对请求后的response进行处理解析
 */
export function defaultResponse(response: any) {
  try {
    if (response.hasOwnProperty("data") && response.status === "ok") {
      return JSON.parse(response.data);
    } else if (response.status === "fail") {
      return Promise.reject(response);
    } else {
      return response;
    }
  } catch (error) {
    return Promise.reject(error);
  }
}
/**
 * 对请求后返回的cookie header进行处理，存储到对应的store内
 * @param response
 */
export function responseBase64(response: any) {
  try {
    if (response.hasOwnProperty("data") && response.hasOwnProperty("meta")) {
      //TODO：服务校验错误后 不会返回base64的编码，而是直接返回错误
      const words = Base64.parse(response.data);
      const textString = Utf8.stringify(words);
      //order暂时这么做
      if (response.hasOwnProperty("pagination")) {
        return {
          ...response,
          data: JSON.parse(textString)
        };
      }
      return JSON.parse(textString);
    } else {
      return response;
    }
  } catch (error) {
    console.error("responseBase64失败", error);
    return Promise.reject(error);
  }
}
